module.exports = __webpack_public_path__ + "4a3724cfe1ffc1f4ae7fa44d1616f683.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/logo.svg
// module id = 1270
// module chunks = 73